import classNames from 'classnames';
import React from 'react';
import './Hero.scss';
import HeroIllustration from './HeroIllustration';
import HeroPrimaryContent from './HeroPrimaryContent';
import SecondaryContent from './HeroSecondaryContent';

export interface HeroProps {
  children: React.ReactNode | React.ReactNode[];
  size?: 'sm' | 'lg';
}

const Hero = ({ children, size = 'sm' }: HeroProps): JSX.Element => {
  const classes = classNames('mss-hero', {
    'mss-hero--sm': size === 'sm',
    'mss-hero--lg': size === 'lg'
  });
  return (
    <section className={classes}>
      <div className="zb-container">
        <div className="mss-hero__container">{children}</div>
      </div>
    </section>
  );
};

Hero.PrimaryContent = HeroPrimaryContent;
Hero.SecondaryContent = SecondaryContent;
Hero.Illustration = HeroIllustration;

export default Hero;
